import UploadPromoPage from './UploadPromoPage';

export default UploadPromoPage;
